// SET USER
const setUserRequest = () => {
  return { type: "SET_USER_REQUEST" };
};

const setUserSuccess = (payload) => {
  sessionStorage.setItem("kzvb-obleute", payload.token);
  return { type: "SET_USER_SUCCESS", payload: payload.payload };
};

const editUser = (payload) => {
  sessionStorage.setItem("kzvb-obleute", payload.token);
  return { type: "EDIT_USER", payload: payload.payload };
};

const setUserFailure = (payload) => {
  return { type: "SET_USER_FAILURE", payload };
};

// ADMIN USERS
const fetchAdminRequest = () => {
  return { type: "FETCH_ADMIN_REQUEST" };
};

const fetchAdminReportedSuccess = (payload) => {
  return { type: "FETCH_ADMIN_REPORTED_SUCCESS", payload };
};

const fetchAdminReportedFailure = (payload) => {
  return { type: "FETCH_ADMIN_REPORTED_FAILURE", payload };
};

const fetchRoomsRequest = () => {
  return { type: "FETCH_ROOMS_REQUEST" };
};

const fetchRoomsSuccess = (payload) => {
  return { type: "FETCH_ROOMS_SUCCESS", payload };
};

const fetchRoomsFailure = (payload) => {
  return { type: "FETCH_ROOMS_FAILURE", payload };
};

// SINGLE MESSAGE
const setMessage = (payload) => {
  return { type: "SET_MESSAGE", payload };
};

const pushMessage = (payload) => {
  return { type: "PUSH_MESSAGE", payload };
};

const updateMessage = (messageID) => {
  return { type: "UPDATE_MESSAGE", payload: messageID };
};

const editMessage = (payload) => {
  return { type: "EDIT_MESSAGE", payload };
};

const likeMessage = (payload) => {
  return { type: "LIKE_MESSAGE", payload };
};

// EDIT ROOM
const editRoomRequest = () => {
  return { type: "EDIT_ROOM_REQUEST" };
};

const editRoomSuccess = (payload) => {
  return { type: "EDIT_ROOM_SUCCESS", payload };
};

const editRoomFailure = (payload) => {
  return { type: "EDIT_ROOM_FAILURE", payload };
};

// DELETE ROOM
const deleteRoomRequest = () => {
  return { type: "DELETE_ROOM_REQUEST" };
};

const deleteRoomSuccess = (payload) => {
  return { type: "DELETE_ROOM_SUCCESS", payload };
};

const deleteRoomFailure = (payload) => {
  return { type: "DELETE_ROOM_FAILURE", payload };
};

const fetchMessagesRequest = () => {
  return { type: "FETCH_MESSAGES_REQUEST" };
};

const fetchMessagesSuccess = (payload) => {
  return { type: "FETCH_MESSAGES_SUCCESS", payload };
};

const fetchMessagesFailure = (payload) => {
  return { type: "FETCH_MESSAGES_FAILURE", payload };
};

const fetchPageMessagesSuccess = (payload) => {
  return { type: "FETCH_PAGE_MESSAGES_SUCCESS", payload };
};

const fetchPageMessagesFailure = (payload) => {
  return { type: "FETCH_PAGE_MESSAGES_FAILURE", payload };
};

const showGallery = (payload) => {
  return { type: "SHOW_GALLERY", payload };
};

const hideGallery = () => {
  return { type: "HIDE_GALLERY" };
};

const showModal = (title, type, size) => {
  return {
    type: "SHOW_MODAL",
    payload: {
      title,
      type,
      size,
    },
  };
};

const hideModal = () => {
  return { type: "HIDE_MODAL" };
};

export {
  setUserRequest,
  setUserSuccess,
  setUserFailure,
  editUser,
  fetchAdminRequest,
  fetchAdminReportedSuccess,
  fetchAdminReportedFailure,
  fetchRoomsRequest,
  fetchRoomsSuccess,
  fetchRoomsFailure,
  editRoomRequest,
  editRoomSuccess,
  editRoomFailure,
  deleteRoomRequest,
  deleteRoomSuccess,
  deleteRoomFailure,
  setMessage,
  editMessage,
  likeMessage,
  pushMessage,
  updateMessage,
  fetchMessagesRequest,
  fetchMessagesSuccess,
  fetchMessagesFailure,
  fetchPageMessagesSuccess,
  fetchPageMessagesFailure,
  showGallery,
  hideGallery,
  showModal,
  hideModal,
};
